<template>
    <v-card>
        <v-layout>
            <v-flex xs12 v-if="!loading && loadError" class="notPrinted">
                <v-alert outline :value="true" color="error" icon="error">
                    {{loadError}}
                </v-alert>
            </v-flex>
            <v-flex xs12 v-if="!loadError" class="notPrinted">
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">GP Reporting</h1>
                    </v-flex>
                </v-layout>
                <v-form v-model="searchFormValid" ref="form">
                    <v-layout wrap>
                        <v-flex xs12 sm2 offset-sm3>
                            <v-autocomplete
                                :items="stores"
                                item-text="Name"
                                item-value="ID"
                                v-model="search.storeIDs"
                                multiple
                                label="Stores"
                                hint="Stores"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-autocomplete
                                :items="departments"
                                item-text="Name"
                                item-value="ID"
                                v-model="search.departmentIDs"
                                multiple
                                label="Departments"
                                hint="Departments"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm3>
                            <v-autocomplete
                                :items="suppliers"
                                item-text="Name"
                                item-value="ID"
                                v-model="search.supplierIDs"
                                multiple
                                label="Supplier"
                                hint="Supplier"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm3>
                            <v-menu
                                ref="datePickerMenu"
                                :close-on-content-click="false"
                                v-model="startDatePickerMenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="search.minDate"
                                    label="Start Date"
                                    prepend-icon="event"
                                    hint="Start Date"
                                    readonly
                                ></v-text-field>
                                <v-date-picker 
                                    :allowed-dates="allowedDates"
                                    v-model="search.minDate"
                                    @input="startDatePickerMenu = false">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 sm2 offset-sm1>
                            <v-menu
                                ref="datePickerMenu"
                                :close-on-content-click="false"
                                v-model="endDatePickerMenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="search.maxDate"
                                    label="End Date"
                                    prepend-icon="event"
                                    hint="End Date"
                                    readonly
                                ></v-text-field>
                                <v-date-picker 
                                    :allowed-dates="allowedDates"
                                    v-model="search.maxDate"
                                    @input="endDatePickerMenu = false">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 sm5 offset-sm3>
                            <v-btn block color="success" :disabled="!searchFormValid" :loading="ordersLoading" @click="loadOrders">Search</v-btn>
                        </v-flex>
                    </v-layout>
                </v-form>
                <v-layout>
                    <v-flex xs12>
                        <v-data-table
                            :headers="headers"
                            :items="orders"
                            :loading="loading"
                            must-sort
                            :rows-per-page-items="rowsPerPage"
                            :pagination.sync="pagination"
                            :total-items="totalOrders"
                        >
                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                            <template slot="items" slot-scope="props">
                                <tr :data-id="props.item.ID" @click="props.expanded = !props.expanded">
                                    <td>{{props.item.ID}}</td>
                                    <td>{{formatDate(props.item.Date)}}</td>
                                    <td>{{props.item.StoreName}}</td>
                                    <td>{{props.item.DepartmentName}}</td>
                                    <td>{{props.item.Suppliers}}</td>
                                    <td>
                                        <v-btn
                                            color="info"
                                            block
                                            @click="loadOrdersProducts(props.item)"
                                        >
                                            View Details
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                            <template v-if="!loading" slot="no-data">
                                <v-alert v-if="loadError" outline :value="true" color="error" icon="error">
                                    {{loadError}}
                                </v-alert>
                                <v-alert v-if="!loadError" outline :value="true" type="info">
                                    No results found
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>
            </v-flex>




            <v-dialog v-model="showViewDetailsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="cancelViewDetailsOrder">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Order Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                        <v-layout class="dialog-content">
                            <v-flex xs12 md12>
                                <v-layout wrap>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="detailsData.ID"
                                            :readonly="true"
                                            label="Order ID">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="viewDetailsOrderDate"
                                            :readonly="true"
                                            label="Order Date">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="detailsData.StoreName"
                                            :readonly="true"
                                            label="Store">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="detailsData.DepartmentName"
                                            :readonly="true"
                                            label="Department">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-data-table
                                            :headers="viewDetailsHeaders"
                                            :items="ordersProductsWithSuppliers"
                                            :loading="viewDetailsDialogLoading"
                                            hide-actions
                                            must-sort
                                        >
                                            <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                            <template slot="items" slot-scope="props">
                                                <tr :data-id="props.item.ID" >
                                                    <td>{{props.item.ProductName}}</td>
                                                    <td>{{props.item.Quantity}}</td>
                                                    <td>{{formatCurrency(props.item.CostPrice)}}</td>
                                                    <td>{{formatCurrency(props.item.CostPrice*props.item.Quantity)}}</td>
                                                    <td>{{formatCurrency(props.item.CostPerUnit)}}</td>
                                                    <td>{{props.item.SellPrice*props.item.Quantity*(props.item.QuantityUnit || 1) >0 ? formatCurrency((props.item.SellPrice*props.item.Quantity*(props.item.QuantityUnit || 1))) :'' }}</td>
                                                    <td :style="{color:handleNegativeNumberStyle(props.item.SellPrice*props.item.Quantity*(props.item.QuantityUnit || 1),props.item.CostPrice*props.item.Quantity)}">{{props.item.CostPrice*props.item.Quantity >0 && props.item.SellPrice*props.item.Quantity*(props.item.QuantityUnit || 1)>0 ? calculateRetailGP(props.item.CostPrice*props.item.Quantity,props.item.SellPrice*props.item.Quantity*(props.item.QuantityUnit || 1)):''}}</td>
                                                    <td>{{props.item.SupplierName}}</td>
                                                    <td>{{formatCurrency(props.item.SellPrice)}}</td>    
                                                </tr>
                                            </template>
                                            <template v-if="!viewDetailsDialogLoading" slot="no-data">
                                                <v-alert v-if="detailsDialogError" outline :value="true" color="error" icon="error">
                                                    {{detailsDialogError}}
                                                </v-alert>
                                                <v-alert v-if="!detailsDialogError" outline :value="true" type="info">
                                                    No results found
                                                </v-alert>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                        <v-data-table
                                            :headers="totalDetailsHeaders"
                                            :items="[{ID:1}]"
                                            :loading="viewDetailsDialogLoading"
                                            hide-actions
                                        >
                                            <template slot="items" slot-scope="props">
                                                <tr :data-id="props.item.ID">
                                                    <td>{{formatCurrency(costOfStock)}}</td>
                                                    <td>{{formatCurrency(totalSell)}}</td>
                                                    <td :style="{color: totalNumberStyle}">{{GP}}</td>
                                                    <td :style="{color: totalNumberStyle}">{{GPPercentage}}</td>
                                                </tr>
                                            </template>

                                     </v-data-table>
                                    <v-flex>
                                    </v-flex>
                                </v-layout>   
                                <v-layout wrap class="dialog-action-buttons notPrinted">
                                    <v-flex xs12 md6>
                                        <v-btn block color="info" @click="cancelViewDetailsOrder">Back</v-btn>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-btn block color="info" @click="triggerPrint">Print</v-btn>
                                    </v-flex>
                                </v-layout>                       
                            </v-flex>
                        </v-layout>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import formatters from "../../helpers/formatters";
import validationRules from "@/helpers/validationrules";
import auth from '@/services/auth';
import util from '@/services/util';
import Vue from 'vue'

export default {
    data() {
        return {
            searchFormValid: false,
            search: {
                storeIDs: [],
                startDate: null,
                endDate: null
            },
            rules: validationRules.rules,
            ordersLoading: false,
            orders: [],
            totalSell:0,
            costOfStock:0,
            totalOrders: 0,
            GP:0,
            GPPercentage:"",
            rowsPerPage: [20, 50, 100],
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "ID",
                descending: true
            },
            startDatePickerMenu: false,
            endDatePickerMenu: false,

            headers: [
                {
                    text: "Order Number",
                    value: "ID",
                    sortable: true
                },
                {
                    text: "Date",
                    value: "Date",
                    sortable: true
               },
                {
                    text: "Store",
                    value: "StoreName",
                    sortable: true
                },
                {
                    text: "Department",
                    value: "DepartmentName"
                },
                {
                    text: "Suppliers",
                    value: "Suppliers"
                },
                {
                    text: "", // view button
                    sortable: false
                }
            ],
            totalDetailsHeaders: [
                {
                    text: "Cost of Stock",
                    value: "CostOfStock",
                    sortable: false
                },
                {
                    text: "Total Retail Sell",
                    value: "TotalRetailSell",
                    sortable: false
               },
                {
                    text: "GP $",
                    value: "GP",
                    sortable: false
                },
                {
                    text: "GP %",
                    value: "GP",
                    sortable: false
                },
                {
                    text: "", // view button
                    sortable: false
                }
            ],
            showViewDetailsDialog: false,
            viewDetailsDialogLoading: false,
            detailsDialogError: "",
            detailsData: {},
            ordersProductsWithSuppliers:[],
            totalNumberStyle: "",
            viewDetailsHeaders: [
                {
                    text: "Item Description",
                    value: "ProductName",
                },
                {
                    text: "Quantity",
                    value: "Quantity",
                },
                {
                    text: "Cost Price",
                    value: "CostPrice",
                },
                {
                    text: "Total Cost",
                    value: "TotalCost",
                    sortable: false
                },
                {
                    text: "Cost/Unit",
                    value: "CostPerUnit",
                },
                {
                    text: "Retail Total",
                    value: "RetailTotal",
                    sortable: false
                },
                {
                    text: "Retail GP %",
                    value: "RetailGP",
                    sortable: false
                },
                {
                    text: "Supplier",
                    value: "SupplierName",
                },
                {
                    text: "Sell",
                    value: "SellPrice",
                }
            ]
        }
    },
    watch: {
        pagination: {
            handler(a, x){
                if (a.page != x.page || a.rowsPerPage != x.rowsPerPage || a.sortBy != x.sortBy || a.descending != x.descending){
                    this.loadOrders();
                }
            },
            deep: true
        }
    },
    computed: {
        loading() {
            return this.ordersLoading
                || this.$store.state.storeStore.loading
                || this.$store.state.supplierStore.loading;
        },
        loadError() {
            return this.$store.state.reportStore.order.loadError;
        },
        stores() {
            return this.$store.state.storeStore.stores.filter(s => s.Active).sort(util.sortByName);
        },
        ordersProducts(){
            return this.$store.state.orderStore.products.ordersProducts.sort(function(a, b) {
                if (a.SupplierName < b.SupplierName) {
                    return -1;
                }
                else if (a.SupplierName > b.SupplierName) {
                    return 1;
                }

                return 0;
            });
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(d => d.Active).sort(util.sortByName);
        },
        suppliers(){
            return this.$store.state.supplierStore.suppliers.filter(c => c.Active);
        },
        viewDetailsOrderDate() {
            if (this.detailsData && this.detailsData.Date){
                return this.formatDate(this.detailsData.Date)
            } else {
                return "";
            }
        }
    },
    methods: {
        loadStores() {
            this.$store.dispatch("storeStore/loadStores");
        },
        loadDepartments() {
            this.$store.dispatch("departmentStore/loadDepartments");
        },
        loadSuppliers() {
            this.$store.dispatch("supplierStore/loadSuppliers");
        },
        loadOrders() {
            this.ordersLoading = true;

            let that = this;
            this.$store.dispatch("orderStore/loadOrders", {
                params: {
                    PaginationPage: this.pagination.page,
                    PaginationPageSize: this.pagination.rowsPerPage,
                    SortBy: this.pagination.sortBy,
                    SortDirection: this.pagination.descending ? "DESC" : "ASC",
                    SearchDate: this.search.date,
                    SearchMinDate: this.search.minDate,
                    SearchMaxDate: this.search.maxDate,
                    SearchStages: JSON.stringify(this.search.stages),
                    SearchStoreIDs: JSON.stringify(this.search.storeIDs),
                    SearchSupplierIDs: JSON.stringify(this.search.supplierIDs),
                    SearchDepartmentIDs: JSON.stringify(this.search.departmentIDs),
                },
                success: (data) => {
                    that.orders = data.Orders;
                    that.totalOrders = data.TotalOrders;
                },
                finally: () => {
                    that.ordersLoading = false;
                }
            });
        },
        allowedDates(val){
            return true;
        },
        clearOrderReports(){
            this.$store.dispatch("reportStore/clearOrderReports");
        },
        formatCurrency(value) {
            if(value == null){
                return;
            }

            return formatters.formatCurrency(value);
        },
        formatDate(value){
            if(value == null){
                return;
            }

            return formatters.formatDate(value);
        },
        handleNegativeNumberStyle(firstValue,SecondValue){
            return firstValue-SecondValue < 0 && "red";
        },
        loadOrdersProducts(item){
            let that = this;
            this.detailsData = item;
            that.viewDetailsDialogLoading = true;
            that.showViewDetailsDialog = true;
            that.ordersProductsWithSuppliers = [];
            this.$store.dispatch("orderStore/loadOrdersProducts", {
                orderID: item.ID,
                SearchSupplierIDs: JSON.stringify(this.search.supplierIDs),
                success: (res) => {
                    that.ordersProductsWithSuppliers = that.getOrdersProductsWithSuppliers();             
                },
                error: (e) => {
                    that.detailsDialogError = e;
                },
                finally: () => {
                    this.calculateCostOfStock();
                    this.calculateTotalRetailSell();
                    that.viewDetailsDialogLoading = false;
                }
            });
        },
        formatDate(dateString){
            let date = new Date(dateString);

            let day = date.getDate() + "";
            if(day.length == 1){
                day = "0" + day;
            }
            let month = date.getMonth() + 1 + "";
            if(month.length == 1){
                month = "0" + month;
            }
            let year = date.getFullYear();

            return day + "/" + month + "/" + year;
        },
        getOrdersProductsWithSuppliers(){
            let that = this;

            return this.ordersProducts.map(oP => {
                let ordersProduct = Object.assign({}, oP);

                let supplier = that.suppliers.find(s => s.ID == ordersProduct.SupplierID);
                if(supplier != null){
                    ordersProduct.Supplier = supplier;
                }
                return ordersProduct;
            }).filter(oP => oP.Supplier != null);
        },
        cancelViewDetailsOrder() {
            this.showViewDetailsDialog = false;
            this.detailsData = {};
        },
        triggerPrint(){
            window.print();
        },
        calculateRetailGP(cost,sell){
            const retailGP = (((sell-cost)/sell)*100).toFixed(2);
            this.calculateTotalRetailSell();
     
             return retailGP;
   
        },
        calculateGP(){
            let result;
            this.totalNumberStyle = "";
            this.GPPercentage = "";
            this.GP = "";
            if(this.totalSell > 0 && this.costOfStock > 0){
                result = ((this.totalSell-this.costOfStock)/this.totalSell)*100;
                this.GPPercentage = result.toFixed(2);
            }
            if(result < 0 || this.totalSell-this.costOfStock < 0){
                this.totalNumberStyle = "red";
            }


            this.GP = this.formatCurrency(this.totalSell-this.costOfStock);
        },
        calculateTotalRetailSell(){

            let totalSell=0;
            this.ordersProductsWithSuppliers.forEach(e =>{
                totalSell += e.SellPrice*e.Quantity*(e.QuantityUnit || 1);
            })

            this.totalSell = totalSell;
            this.calculateGP();
        },

        calculateCostOfStock(){
            let totalCostStock = 0;
            this.ordersProductsWithSuppliers.forEach(e =>{
                totalCostStock += e.CostPrice*e.Quantity;
            })

            this.costOfStock = totalCostStock;
        },

  
    },
    created() {
        this.loadStores();
        this.loadDepartments();
        this.loadSuppliers();

        if(!this.search){
            this.search = {};
        }

        if(!this.search.minDate){
            this.search.minDate = "";
        }

        if(!this.search.maxDate){
            this.search.maxDate = "";
        }

        if(!this.search.storeIDs){
            this.search.storeIDs = [];
        }

        if(!this.search.departmentIDs){
            this.search.departmentIDs = [];
        }

        if(!this.search.supplierIDs){
            this.search.supplierIDs = [];
        }
    }
}
</script>

<style>

    .inputValue{
        width: 80px;
    }

</style>